<template>
  <Modal :id="id" class="fullscreen overlay"
         title="详细信息" hide_footer="true" scrollable="true">
    <div v-if="entry" class="ui form break-words">
      <div class="field">
        <label>
          项目名称
        </label>
        <div v-if="editing" class="ui fluid icon input">
          <input name="new-entry-name" maxlength="128" v-model="editing_entry.name" type="text" id="entry_detail_name"/>
          <i class="ui yellow text star link icon" :class="{ outline: !editing_entry.fav }"
             data-content="加入收藏"
             @click="editing_entry.fav=!editing_entry.fav"></i>
        </div>
        <div v-else>
          {{ entry.name }}
          <span v-if="entry.fav">
            <i class="ui yellow text star icon"></i>
          </span>
        </div>
      </div>
      <div v-if="entry.url || editing" class="field">
        <label>网址</label>
        <div v-if="editing" class="ui fluid input">
          <input id="new_entry_url" name="new_entry_url" v-model="editing_entry.url" class="form-control" type="text"/>
        </div>
        <div v-else>
        {{ entry.url }}
        <a class="quickicon" @click="copy_to_clipboard($event, entry.url, '网址')">
          <i class="copy icon"></i>
        </a>
        </div>
      </div>
      <div v-if="entry.username || editing" class="field">
        <label>账号</label>
        <div v-if="editing" class="ui fluid input">
          <input id="new_entry_username" name="new_entry_username" maxlength="128" v-model="editing_entry.username" type="text"/>
        </div>
        <div v-else>
          {{ entry.username }}
          <a class="quickicon" @click="copy_to_clipboard($event, entry.username, '用户名')">
            <i class="copy icon"></i>
          </a>
        </div>
      </div>
      <div v-if="entry.password || editing" class="field">
        <label>
          密码
          <a v-if="!editing && show_password" class="quickicon"
             @click="show_password=false;">
            <i class="eye slash icon"></i>
          </a>
          <a v-else-if="!editing" class="quickicon"
             @click="show_password=true;">
            <i class="eye icon"></i>
          </a>
        </label>
        <PasswordInput ref="pwinput" v-if="editing" v-model="editing_entry.password" />
        <div v-else>
          <span v-if="show_password">{{ entry.password }}</span>
          <span v-else>••••••••••</span>
          <a v-if="!editing" class="quickicon"
                          @click="copy_to_clipboard($event, entry.password, '密码')">
            <i class="copy icon"></i>
          </a>
        </div>
      </div>
      <div v-if="(entry.tags && entry.tags.length) || editing" class="field">
        <label>标签</label>
        <TagInput v-if="editing" v-model="editing_entry.tags" />
        <div v-else>
          <span v-for="t in entry.tags" :key="t" class="ui tag label">
            {{ t }}
          </span>
        </div>
      </div>
      <div v-if="entry.notes || editing" class="field">
        <label>备注</label>
        <textarea v-if="editing" v-model="editing_entry.notes" class="form-control" rows=5 name="entry_detail_notes" id="entry_detail_notes"></textarea>
        <div v-else>
          <span v-for="(l, i) in notes_lines" :key="i">{{ l }}<br></span>
        </div>
      </div>
      <div class="mt-6">
        <button v-if="editing" :disabled="saving" :class="{loading:saving}" class="ui teal button" @click="save">
          <i class="save icon"></i>
          保存
        </button>
        <button v-else class="ui button" @click="edit(entry)">
          <i class="edit icon"></i>
          修改
        </button>
        <button v-if="!creating" class="ui button" @click="show_modal('delete-entry-' + _uid, true)">
          <i class="trash alterate icon"></i>
          删除
        </button>
        <button v-if="editing" class="ui button" @click="cancel">
          <i class="undo alternate icon"></i>
          取消
        </button>
        <button v-if="!creating" class="ui button" @click="close_request">
          <i class="window close icon"></i>
          关闭
        </button>
      </div>
      <Modal ok-title="确定" cancel-title="取消" :id="'modal-close-' + _uid" title="关闭" @ok="really_close">
        <p>修改还没有保存，确认关闭吗？未保存的改动会被丢弃。</p>
      </Modal>
      <Modal ok-title="确定" cancel-title="取消" :id="'delete-entry-' + _uid" title="删除" @ok="del">
        <p>确定要删除项目吗？</p>
      </Modal>
    </div>
  </Modal>
</template>

<script>
import PasswordInput from './password-input.vue';
import TagInput from './tag-input.vue';
import Modal from './modal.vue';

export default {
  name: '',
  props: ['id'],
  components: {
    PasswordInput,
    TagInput,
    Modal,
  },
  data: function () {
    return {
      entry: null,
      editing_entry: null,
      show_password: false,
      editing: false,
      creating: false,
      saving: false,
    };
  },
  computed: {
    modified() {
      console.log(this.entry);
      return this.editing && JSON.stringify(this.editing_entry) != JSON.stringify(this.entry);
    },
    notes_lines() {
      var r = this.entry.notes.split("\n");
      console.log(this.entry.notes);
      console.log(r);
      return r;
    },
  },
  methods: {
    close() {
      this.hide_modal(this.id);
    },
    reset_saving() {
      this.saving = false;
    },
    make_new_entry() {
      return {
        'id': '',
        'name': '',
        'url': '',
        'username': '',
        'password': '',
        'notes': '',
        'tags': [],
        'fav': false,
        'create_time': Date.now(),
        'update_time': Date.now(),
        'custom_fields': []
      };
    },
    reset() {
      this.show_password = false;
      this.saving = false;
      if (this.$refs.pwinput) {
        this.$refs.pwinput.reset();
      }
    },
    view(e) {
      console.log("view", e);
      this.editing = false;
      this.creating = false;
      this.entry = e;
      this.reset();
      this.show_modal(this.id, false, {
        autofocus: false,
      });
    },
    create() {
      this.edit(this.make_new_entry(), true);
    },
    edit(e, creating=false) {
      this.entry = e;
      this.editing = true;
      this.creating = creating;
      this.editing_entry = this.copy_entry(e);
      process.nextTick(() => {
        this.reset();
        this.show_modal(this.id, false, {
          closable: false,
        });
      });
    },
    del() {
      this.$(".ui.modal").modal("hide all");
      this.$emit('delete_entry', this.entry);
    },
    copy_to_clipboard(e, text, item_name='') {
      this.$gtag.event('copy-new-password', {
        event_category: 'user-action',
        event_label: 'password-manager',
      });
      var dummy = document.createElement("textarea");
      e.target.appendChild(dummy);
      dummy.value = text;
      dummy.select();
      document.execCommand("copy");
      e.target.removeChild(dummy);
      this.show_success(item_name + "已复制到剪贴板");
    },
    start_edit() {
      this.editing_entry = this.copy_entry(this.entry);
      this.$emit('start_edit');
    },
    close_request(e) {
      if (this.modified) {
        this.show_modal('modal-close-' + this._uid, true);
        e.preventDefault();
      } else {
        this.really_close();
      }
    },
    really_close() {
      this.$(".ui.modal").modal("hide all");
    },
    save() {
      this.saving = true;
      if (this.creating) {
        this.$emit("create", this.editing_entry);
      } else {
        this.$emit("save", this.editing_entry);
      }
    },
    copy_entry(e) {
      return JSON.parse(JSON.stringify(e));
    },
    cancel() {
      if (this.creating) {
        this.hide_modal(this.id);
      } else {
        this.editing = false;
      }
    },
  },
  mounted() {
  },
}
</script>

<style scoped>
.lg .quickicon {
  opacity: 0;
}

.quickicon {
  color: #666;
  margin-left: 8px;
}
div.field:hover .quickicon {
  opacity: 1;
}
</style>
